import axiosClient from '@/config/api/axios'
import { INTEGRATION_PROPOSALS } from '@/config/api/endpoints'

/** One stored proposal, flattened for the UI. */
function toProposal(row = {}) {
  const spec = row.spec && typeof row.spec === 'object' ? row.spec : {}
  return {
    id: String(row.id ?? ''),
    tool: String(row.tool_slug ?? ''),
    toolkit: spec.toolkit ?? null,
    summary: String(row.title ?? row.tool_slug ?? ''),
    argumentsPreview: spec.arguments ?? {},
    principal: spec.principal ?? {},
    destructive: Boolean(spec.destructive),
    status: String(row.status ?? 'pending'),
    error: row.error ?? null,
    workStatus: row.work_status ?? null,
    expiresAt: row.expires_at ?? null,
    createdAt: row.created_at ?? null,
    conversationId: row.conversation_id ? String(row.conversation_id) : null,
  }
}

/**
 * Write actions waiting on this user, newest first.
 *
 * Server-side the list is already scoped to the caller, so there is no user id
 * to pass and no way to ask for someone else's.
 */
export async function fetchProposals({ conversationId, signal } = {}) {
  const { data } = await axiosClient.get(INTEGRATION_PROPOSALS, {
    params: conversationId ? { conversation_id: conversationId } : undefined,
    signal,
  })
  return (Array.isArray(data) ? data : []).map(toProposal)
}

/** One proposal by id. Used to resolve a card's true state after a reload. */
export async function fetchProposal({ proposalId, signal }) {
  const { data } = await axiosClient.get(`${INTEGRATION_PROPOSALS}/${proposalId}`, { signal })
  return toProposal(data)
}
